import styled from 'styled-components';
import { Button } from '../../utils/Button/Button';

export const Form = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  width: 35rem;
  margin-top: auto;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  gap: 0.2rem;
  flex-wrap: wrap;
  margin-bottom: 1.6rem;
  padding: 0.1rem;
  align-content: baseline;
  width: 100%;
  min-height: 24.4rem;
`;
